class MFRAisleForm {
  constructor(index, element) {
    this.$element = $(element)

		this.selectors = {
			phoneInput: "#aisle-form-input-phoneNumber-field",
			emailInput: "#aisle-form-input-email-field",
			submitButton: ".aisle-form-button",
			consentMessage: ".aisle-form-legal-container",
			errorMessage: ".aisle-form-input-text-error"
		}

		this.config = {
			attributes: true,   
			childList: true, 
			subtree: true
		}

    this.init()
  }

  init() {
		this.$phoneInput = this.$element.find(this.selectors.phoneInput)
		this.$emailInput = this.$element.find(this.selectors.emailInput)
		this.$errorMessage = this.$element.find(this.selectors.errorMessage)
		this.$consentMessage = this.$element.find(this.selectors.consentMessage)
		this.$submitButton = this.$element.find(this.selectors.submitButton)

		this.__handleAisleFormDOMMutation()
		this.__handleFormInputReplacePlaceholders()
  }

	__handleAisleFormDOMMutation() {
    let isLoaded = false;
		const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          if (isLoaded) return;
          this.$submitButton = this.$element.find(this.selectors.submitButton);

          this.$submitButton.on('click', () => {
            const $errors = this.$errorMessage

            if ( $errors.length > 0 ) return

						console.log('Aisle form submit: success')

						this.$consentMessage.hide()

						fbq('trackCustom', 'SignUp')
						ttq.track('SignUp')
						gtag('event', 'SignUp', {
							send_to: 'G-F8JCD6WD69',
							page_title: 'SMS Sign Up',
							page_path: '/sms-signup',
						})
          })
          isLoaded = true;
        }
      }
    })

		observer.observe(this.$element.get(0), this.config)
	}

	__handleFormInputReplacePlaceholders() {
		setTimeout(() => {
			if ( this.$phoneInput.length > 0 ) {
				this.$phoneInput.attr('placeholder', this.$phoneInput.attr('placeholder').replaceAll('.', ''))
			}

			if ( this.$emailInput.length > 0 ) {
				this.$emailInput.attr('placeholder', this.$emailInput.attr('placeholder').replaceAll('.', ''))
			}
		}, 3000)
	}
}